import React, { Component } from "react";
import DesignTool from "../../designtool";
import {filter} from "lodash";

const TYPE_ZOOM_IN = 1;
const TYPE_ZOOM_OUT = 0;

export default class ButtonZoom extends Component {
  handleZoom(type_zoom) {
    let {
        ringIdActive,
    } = this.props;
    if(type_zoom == TYPE_ZOOM_IN){
      DesignTool.touchZoom(1,2, ringIdActive)
    }else{
      DesignTool.touchZoom(2,1, ringIdActive)
    }
  }

  render() {
    return (
        <div className="content_btn_zoom">
          <button className={`btn_zoom btn_zoom_in ${this.props.isShowPopupSp ? 'is_show' : ''}`} id="btn_zoom_in" onClick={() => this.handleZoom(TYPE_ZOOM_IN)}><span>+</span>
          </button>
          <button className={`btn_zoom btn_zoom_out disabled_button ${this.props.isShowPopupSp ? 'is_show' : ''}`} id ="btn_zoom_out" onClick={() => this.handleZoom(TYPE_ZOOM_OUT)}><span>-</span>
          </button>
        </div>
    );
  }
}
